import { Box, styled } from "@mui/system";

export const CategoryListItemContainer = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey.main}`,
  padding: theme.spacing(1, 0),
  "& .categoryListingItem": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    overflow: "hidden",
  },
  "& .categoryListingItem .categoryBox": {
    width: "100%",
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
  "& .category-region": {
    margin: 0,
    marginBottom: theme.spacing(0.5),
    color: theme.palette.grey.blueGrey,
    fontSize: theme.typography.pxToRem(13),
  },
  "& .category-text": {
    fontSize: theme.typography.pxToRem(15),
    width: "95%",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  "& .category-actions": {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.25),
    marginTop: theme.spacing(1),
  },
  "& .category-actions.with-description": {
    flexWrap: "nowrap",
    alignItems: "flex-start",
    columnGap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
  },
  "& .category-field": {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    flex: "1 1 320px",
    gap: theme.spacing(0.5),
  },
  "& .description-field": {
    flex: "1 1 55%",
    minWidth: "240px",
  },
  "& .category-actions.with-description .member-field": {
    flex: "0 0 280px",
  },
  "& .member-field.align-right": {
    justifyContent: "flex-end",
    maxWidth: "320px",
  },
  "& .category-select": {
    fontSize: theme.typography.pxToRem(15),
    width: "100%",
  },
  "& .field-label": {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.black.main,
    minWidth: "auto",
    fontWeight: 500,
    whiteSpace: "normal",
    marginBottom: theme.spacing(0.25),
  },
  "& .field-control": {
    flex: 1,
  },
  "& .check_box": {
    minWidth: 0,
  },
  "& .numberingWrapper": {
    height: theme.spacing(6.5),
    background: theme.palette.grey.light,
    minWidth: theme.spacing(5),
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
  },
  "&.compactSelectableItem": {
    padding: theme.spacing(0.25, 0.5),
    "& .check_box": {
      minWidth: theme.spacing(4),
    },
    "& .MuiCheckbox-root": {
      padding: theme.spacing(0.5),
    },
    "& .MuiListItemText-root": {
      margin: 0,
    },
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(14),
    },
  },
}));

export default CategoryListItemContainer;
